class NotificationService {
  static async sendSubscriptionStatusEmail(email, { type, tier, endDate, status }) {
    try {
      const response = await fetch('/api/notifications/send', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          type,
          tier,
          endDate,
          status
        })
      });

      if (!response.ok) {
        throw new Error('Failed to send notification');
      }

      return await response.json();
    } catch (error) {
      console.error('Notification sending failed:', error);
      throw error;
    }
  }

  static async sendPaymentFailedEmail(email, { amount, nextRetryDate }) {
    return this.sendSubscriptionStatusEmail(email, {
      type: 'payment_failed',
      amount,
      nextRetryDate
    });
  }
}

export default NotificationService; 